import React from 'react';
import { useParams } from 'react-router';

// mui
import { Typography } from '@mui/material';

// collections
import JobDaysForJob from './collections/JobDaysForJob/JobDaysForJob.collection';
import EquipmentRequestsForJob from './collections/EquipmentRequestsForJob/EquipmentRequestsForJob.collection';
import JobInfo from './collections/JobInfo/JobInfo.collection';
import JobName from './collections/JobName/JobName.collection';

export default function JobDetails() {

    const { jobId } = useParams()
    
    // ✅ FIX: Parse the ID to integer
    const parsedJobId = parseInt(jobId, 10)

    // ✅ Add validation
    if (isNaN(parsedJobId)) {
        return (
            <div>
                <Typography variant="h4" color="error">Invalid Job ID</Typography>
            </div>
        )
    }

    return (
        <div>
            {/* ✅ Use parsedJobId (integer) instead of jobId (string) */}
            <JobName jobId={parsedJobId} />
            <JobInfo jobId={parsedJobId} />

            <Typography variant="h4">Job Days</Typography>
            <JobDaysForJob jobId={parsedJobId} />

            <Typography variant="h4">Requests</Typography>
            <EquipmentRequestsForJob jobId={parsedJobId} />
        </div>
    )
}
